/**
 * 渠道库存枚举（部分）
 */

// 是否(1-2)（1.是、2.否）
export enum NumYesOrNo {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 2
}
export enum NumYesOrNoName {
  /**
   * 是
   */
  YES = '是',
  /**
   * 否
   */
  NO = '否'
}


//例外规则类型（1、2、3、4）
export enum RuleType {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4
}
export enum RuleTypeName {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4'
}

// 同步方式(0.增量、1.全量)
export enum SyncTypeEnum {
  /**
   * 增量
   */
  INCREMENT = 0,
  /**
   * 全量
   */
  FULL = 1
}
export enum SyncTypeEnumName {
  /**
   * 增量
   */
  INCREMENT = '增量',
  /**
   * 全量
   */
  FULL = '全量'
}

// 同步状态(0.同步失败， 1.同步成功， 2.从未同步)
export enum SyncStatusEnum {
  /**
   * 待同步
   */
  WAIT = 0,
  /**
   * 已同步
   */
  SYNC = 1,
  /**
   * 从未同步
   */
  NEVER = 2
}
export enum SyncStatusEnumName {
  /**
   * 待同步
   */
  WAIT = '待同步',
  /**
   * 已同步
   */
  SYNC = '已同步',
  /**
   * 从未同步
   */
  NEVER = '从未同步'
}


// 同步频率(2.低频、1.高频)
export enum SyncFrequencyEnum {
  /**
   * 低频
   */
  LOW = 2,
  /**
   * 高频
   */
  HIGH = 1
}
export enum SyncFrequencyEnumName {
  /**
   * 低频
   */
  LOW = '低频',
  /**
   * 高频
   */
  HIGH = '高频'
}

// 是否同步，1：开启同步，2：暂停同步
export enum StatusSyncEnum {
  /**
   * 开启同步
   */
  ENABLE = 1,
  /**
   * 暂停同步
   */
  DISABLE = 2
}
export enum StatusSyncEnumName {
  /**
   * 开启同步
   */
  ENABLE = '开启同步',
  /**
   * 暂停同步
   */
  DISABLE = '暂停同步'
}

// 例外规则类型（0.无例外规则、1.不可销售库存、2.同步百分比、3.同步固定数量、4.同步增加数量）
export enum RuleTypeEnum {
  /**
   * 无例外规则
   */
  NO_RULE = 0,
  /**
   * 不可销售库存
   */
  NO_SALE = 1,
  /**
   * 同步百分比
   */
  PERCENTAGE = 2,
  /**
   * 同步固定数量
   */
  FIXED = 3,
  /**
   * 同步增加数量
   */
  INCREMENT = 4
}
export enum RuleTypeEnumName {
  /**
   * 无例外规则
   */
  NO_RULE = '无例外规则',
  /**
   * 不可销售库存
   */
  NO_SALE = '不可销售库存',
  /**
   * 同步百分比
   */
  PERCENTAGE = '同步百分比',
  /**
   * 同步固定数量
   */
  FIXED = '同步固定数量',
  /**
   * 同步增加数量
   */
  INCREMENT = '同步增加数量'
}

//日志类型（1：更新， 2：同步）
export enum LogTypeEnum {
  /**
   * 更新
   */
  UPDATE = 1,
  /**
   * 同步
   */
  SYNC = 2
}
export enum LogTypeEnumName {
  /**
   * 更新
   */
  UPDATE = '更新',
  /**
   * 同步
   */
  SYNC = '同步'
}
